import { render } from "./detail.vue?vue&type=template&id=33df1dd8&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=33df1dd8&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33df1dd8"],['__file',"src/views/mediaLibrary/tag/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33df1dd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33df1dd8', __exports__)) {
    console.log('reload')
    api.reload('33df1dd8', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=33df1dd8&scoped=true", () => {
    console.log('re-render')
    api.rerender('33df1dd8', render)
  })

}


export default __exports__